export default "__VITE_ASSET__DRQwRu3y__"